import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import moment from "moment";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebProgressbarComponent } from "../common/selltowebprogressbar/SelltoWebProgressbarComponent";
import { SellToWebTopPanelComponent } from "../common/selltowebtoppanel/SellToWebTopPanelComponent";
import { SellToWebRightPanelComponent } from "../common/selltowebrightpanel/SellToWebRightPanelComponent";
import { SellToWebButtonComponent } from "../common/selltowebbutton/SellToWebButtonComponent";
import { SellToWebInputComponent } from "../common/selltowebinput/SellToWebInputComponent";
import { SellToWebRadioButtonComponent } from "../common/selltowebradiobutton/SellToWebRadioButtonComponent";

export class YourDetailsRouteComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            firstNameChanged: false,
            lastName: "",
            lastNameChanged: false,
            email: "",
            emailChanged: false,
            phone: "",
            phoneChanged: false,
            zipCode: "",
            zipCodeChanged: false,
            isGetOfferClicked: false,
            showSpinner: false,
            redirectTo: "",
            useLocations: false,
            tenantLocation: [],
            selectedLocation: null
        };
        this.onInputValueChange = this.onInputValueChange.bind(this);
        this.onBackButtonClick = this.onBackButtonClick.bind(this);
        this.onGetOfferClick = this.onGetOfferClick.bind(this);
        this.onPhoneBlur = this.onPhoneBlur.bind(this);
        this.onPhoneChange = this.onPhoneChange.bind(this);
        this.onZipCodeChange = this.onZipCodeChange.bind(this);
        this.onTextKeyDown = this.onTextKeyDown.bind(this);
        this.onLocationChange = this.onLocationChange.bind(this);
    }

    pageTitle = "Your Details";

    componentDidMount() {
        let homeData = CommonService.getSessionStorage("homeData");
        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        let vehicleConditionData = CommonService.getSessionStorage("vehicleConditionData");
        try {
            this.props.onPageLoad({ pageTitle: this.pageTitle });
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/your-details", pageType: "Consumer", isLoggedIn: "No", properties: { vin: homeData?.vin, vehicleId: vehicleDetailsData?.selectedTrim?.vehicleId, tenantName: this.props.tenantName, siteName: this.props.siteName } });
            if (!homeData || !vehicleDetailsData || !vehicleConditionData) {
                CommonService.clientAzureStorageLog("YourDetailsRouteComponent", "componentDidMount", "Session data missing.", "Redirect to unique-vehicle", null, null, this.props.applicationInsights);
                this.setState({ showSpinner: false, redirectTo: "/unique-vehicle" });
            }
            else {
                CommonService.clientAzureStorageLog("YourDetailsRouteComponent", "componentDidMount", homeData.vin, (vehicleDetailsData.selectedTrim.vehicleId ?? vehicleDetailsData.selectedTrim.description.trim), null, null, this.props.applicationInsights);
                this.getPageInfo();
                //Get Local Storage Data
                let selectedTrimKey = vehicleDetailsData.selectedTrim.vehicleId ?? vehicleDetailsData.selectedTrim.description.trim;
                let lsFirstName = CommonService.getLocalStorage(selectedTrimKey + "FirstName");
                let lsLastName = CommonService.getLocalStorage(selectedTrimKey + "LastName");
                let lsEmail = CommonService.getLocalStorage(selectedTrimKey + "Email");
                let lsPhone = CommonService.getLocalStorage(selectedTrimKey + "Phone");
                let lsZip = CommonService.getLocalStorage(selectedTrimKey + "Zip");

                this.setState({
                    firstName: lsFirstName,
                    lastName: lsLastName,
                    email: lsEmail,
                    phone: lsPhone,
                    zipCode: lsZip
                });
            }
        }
        catch (error) {
            console.logError(error, "YourDetailsRouteComponent", "componentDidMount", homeData?.vin + " " + (vehicleDetailsData?.selectedTrim?.vehicleId ?? vehicleDetailsData?.selectedTrim?.description?.trim));
        }
    }

    emailRegex = /^([\w-.+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    phoneRegex = /^\d{0,11}$/;
    zipcodeRegex = /^\d{0,5}$/;

    getPageInfo() {
        try {
            this.props.applicationInsights.trackTrace({ message: "YourDetailsRouteComponent/getPageInfo", properties: { tenantName: this.props.tenantName, siteName: this.props.siteName } });
            fetch("/YourDetails/GetPageInfo", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    let tenantLocation = parsedResponse.tenantLocation;
                    tenantLocation.forEach(rowData => {
                        rowData.display_name = rowData.name + " : ";
                        rowData.address = (rowData.address1 ? rowData.address1 + " " : "") +
                            (rowData.address2 ? rowData.address2 + " " : "") +
                            (rowData.city ? rowData.city + " " : "") +
                            (rowData.state ? rowData.state + " " : "") +
                            rowData.zip;

                        rowData.addressLink = "https://www.google.com/maps/place/" + rowData.address.replaceAll(' ', '+');
                    });

                    let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
                    let selectedTrimKey = vehicleDetailsData.selectedTrim.vehicleId ?? vehicleDetailsData.selectedTrim.description.trim;
                    let lsLocation = CommonService.getLocalStorage(selectedTrimKey + "Location");
                    let selectedLocation = null;
                    if (lsLocation) {
                        selectedLocation = tenantLocation.find(location => location.name === lsLocation);
                    }

                    this.setState({
                        useLocations: parsedResponse.site[0].useLocations,
                        tenantLocation: tenantLocation,
                        selectedLocation: selectedLocation
                    });
                })
                .catch(notOKResponse => {
                    this.setState({ showSpinner: false });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/YourDetails/GetPageInfo", ...parsedError, tenantName: this.props.tenantName, siteName: this.props.siteName } });
                                console.logError(parsedError, "HomeRouteComponent", "getPageInfo", this.state.vinOrLicensePlate.toUpperCase());
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "HomeRouteComponent", "getPageInfo", this.state.vinOrLicensePlate.toUpperCase());
                            });
                    }
                });
        } catch (error) {
            console.logError(error, "HomeRouteComponent", "getPageInfo");
        }
    }

    onPhoneBlur(id, value) {
        try {
            let cleaned = ('' + value).replace(/\D/g, '');
            let match = null;
            if (cleaned.toString().length === 10) {
                match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
                value = '(' + match[1] + ') ' + match[2] + '-' + match[3];
                this.setState({
                    [id]: value
                });
            }
            else if (cleaned.toString().length > 10) {
                match = cleaned.match(/^(\d+)(\d{3})(\d{3})(\d{4})$/);
                value = '+' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4];
                this.setState({
                    [id]: value
                });
            }
        }
        catch (error) {
            console.logError(error, "YourDetailsRouteComponent", "onPhoneBlur", id, value);
        }
    }

    onPhoneChange(id, value) {
        try {
            let cleaned = value.replace(/\D/g, "")
            if (value === "" || this.phoneRegex.test(cleaned)) {
                this.setState({
                    [id]: value,
                    [id + "Changed"]: true
                });
            }
        }
        catch (error) {
            console.logError(error, "YourDetailsRouteComponent", "onPhoneChange", id, value);
        }
    }

    onZipCodeChange(id, value) {
        try {
            if (value === "" || this.zipcodeRegex.test(value)) {
                this.setState({
                    [id]: value,
                    [id + "Changed"]: true
                });
            }
        }
        catch (error) {
            console.logError(error, "YourDetailsRouteComponent", "onZipCodeChange", id, value);
        }
    }

    onLocationChange(id, value) {
        try {
            this.setState({ selectedLocation: value });
        }
        catch (error) {
            console.logError(error, "YourDetailsRouteComponent", "onLocationChange", id);
        }
    }

    onInputValueChange(id, value) {
        try {
            this.setState({
                [id]: value,
                [id + "Changed"]: true
            });
        }
        catch (error) {
            console.logError(error, "YourDetailsRouteComponent", "onInputValueChange", id, value);
        }
    }

    onTextKeyDown(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            this.onGetOfferClick();
        }
    }

    onGetOfferClick() {
        let homeData = CommonService.getSessionStorage("homeData");
        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        let vehicleConditionData = CommonService.getSessionStorage("vehicleConditionData");
        try {
            if (!this.state.isGetOfferClicked) {
                this.setState({ isGetOfferClicked: true });
            }

            let inputsValid = this.state.firstName && this.state.lastName && this.state.email
                && this.state.phone && this.state.phone.length >= 10
                && this.state.zipCode && this.state.zipCode.length === 5
                && this.emailRegex.test(this.state.email) === true
                && (!this.state.useLocations || this.state.selectedLocation);

            if (inputsValid) {
                this.setState({ showSpinner: true });
                //Set Local Storage
                let selectedTrimKey = vehicleDetailsData.selectedTrim.vehicleId ?? homeData.vin;
                CommonService.setLocalStorage(selectedTrimKey + ".FirstName", this.state.firstName);
                CommonService.setLocalStorage(selectedTrimKey + ".LastName", this.state.lastName);
                CommonService.setLocalStorage(selectedTrimKey + ".Email", this.state.email);
                CommonService.setLocalStorage(selectedTrimKey + ".Phone", this.state.phone.replace(/\D/g, ''));
                CommonService.setLocalStorage(selectedTrimKey + ".Zip", this.state.zipCode);
                CommonService.setLocalStorage(selectedTrimKey + ".Location", this.state.selectedLocation?.name ?? "");
                let offerDate = moment.utc().format("yyyyMMDDTHHmmss");
                let offerNumber = offerDate + "." + CommonService.createGuid();
                let inputData = {};
                inputData = {
                    source: "AcquireCars",
                    offerNumber: offerNumber,
                    landingUrl: homeData.landingUrl,
                    vin: homeData.vin,
                    licensePlate: homeData.licensePlate ?? "",
                    licensePlateState: homeData.licenseState ?? "",
                    odometer: vehicleDetailsData.odometer,
                    imageUrl: vehicleDetailsData.imageUrl,
                    colorCode: vehicleDetailsData.selectedVehicleOEMColor.code ?? "",
                    colorTitle: vehicleDetailsData.selectedVehicleOEMColor.title ?? "",
                    colorSimpleTitle: vehicleDetailsData.selectedVehicleOEMColor.simpletitle ?? vehicleDetailsData.selectedVehicleOEMColor.optionName,
                    colorRgb1: vehicleDetailsData.selectedVehicleOEMColor.rgb1 ?? "",
                    colorRgb2: vehicleDetailsData.selectedVehicleOEMColor.rgb2 ?? "",
                    year: vehicleDetailsData.selectedTrim.description.year,
                    make: vehicleDetailsData.selectedTrim.description.make,
                    model: vehicleDetailsData.selectedTrim.description.model,
                    trim: vehicleDetailsData.selectedTrim.description.trim,
                    mmrValuesReponseItemIndex: vehicleDetailsData.mmrValuesReponseItemIndex,
                    owners: vehicleDetailsData.autocheckData.ownerCount,
                    accidentCount: vehicleDetailsData.autocheckData.accidentCount,
                    autocheckResponse: vehicleDetailsData.autocheckData.autocheckResponse,
                    accidentResponse: vehicleConditionData.accidentResponse,
                    exterior: vehicleConditionData.exterior,
                    interior: vehicleConditionData.interior,
                    mechanical: vehicleConditionData.mechanical,
                    tire: vehicleConditionData.tire,
                    windshield: vehicleConditionData.windshield,
                    first: this.state.firstName,
                    last: this.state.lastName,
                    email: this.state.email,
                    phone: this.state.phone.replace(/\D/g, ''),
                    zip: this.state.zipCode,
                    useLocations: this.state.useLocations,
                    locationName: this.state.selectedLocation?.name ?? "",
                    locationAddress1: this.state.selectedLocation?.address1 ?? "",
                    locationAddress2: this.state.selectedLocation?.address2 ?? "",
                    locationCity: this.state.selectedLocation?.city ?? "",
                    locationState: this.state.selectedLocation?.state ?? "",
                    locationZip: this.state.selectedLocation?.zip ?? ""
                }

                this.props.applicationInsights.trackTrace({ message: "YourDetailsRouteComponent/onGetOfferClick", properties: { ...inputData, tenantName: this.props.tenantName, siteName: this.props.siteName } });
                fetch("/YourDetails/GetOffer", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8;",
                        "X-XSRF-TOKEN-ACQUIRECARS": CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")
                    },
                    body: JSON.stringify(inputData),
                    credentials: "same-origin"
                })
                    .then(response => { if (response.ok) { return response.json() } else { throw response; } })
                    .then(parsedResponse => {
                        CommonService.clearLocalStorage(homeData.vin, vehicleDetailsData?.selectedTrim?.vehicleId);
                        if (parsedResponse.status === "Created") {
                            let yourDetailsData = {};
                            yourDetailsData.customerInfo = {};
                            yourDetailsData.customerInfo.first = this.state.firstName;
                            yourDetailsData.customerInfo.last = this.state.lastName;
                            yourDetailsData.customerInfo.email = this.state.email;
                            yourDetailsData.customerInfo.phone = this.state.phone.replace(/\D/g, '');
                            yourDetailsData.customerInfo.zip = this.state.zipCode;
                            yourDetailsData.offer = parsedResponse;
                            CommonService.setSessionStorage("yourDetailsData", yourDetailsData);

                            this.setState({ showSpinner: false, redirectTo: "/vehicle-offer" });
                        }
                        else {
                            CommonService.clientAzureStorageLog("YourDetailsRouteComponent", "onGetOfferClick", "fetch GetOffer " + homeData.vin + " " + (vehicleDetailsData.selectedTrim.vehicleId ?? vehicleDetailsData.selectedTrim.description.trim), "Redirect to unique-vehicle", parsedResponse.errorMessage, null, this.props.applicationInsights);
                            this.setState({ showSpinner: false, redirectTo: "/unique-vehicle" });
                        }
                    })
                    .catch(notOKResponse => {
                        if (notOKResponse.status === 400) {
                            CommonService.clientAzureStorageLog("YourDetailsRouteComponent", "onGetOfferClick", "Validation Failed " + homeData.vin + " " + (vehicleDetailsData.selectedTrim.vehicleId ?? vehicleDetailsData.selectedTrim.description.trim), "Redirect to unique-vehicle", null, null, this.props.applicationInsights);
                            this.setState({ showSpinner: false, redirectTo: "/unique-vehicle" });
                        }
                        if (notOKResponse.status === 500) {
                            notOKResponse.json()
                                .then(parsedError => {
                                    this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Api/CalculateOffer", ...inputData, ...parsedError, tenantName: this.props.tenantName, siteName: this.props.siteName } });
                                    console.logError(parsedError, "YourDetailsRouteComponent", "onGetOfferClick", homeData.vin + " " + (vehicleDetailsData.selectedTrim.vehicleId ?? vehicleDetailsData.selectedTrim.description.trim));
                                })
                                .catch(jsonParseError => {
                                    console.logError(jsonParseError, "YourDetailsRouteComponent", "onGetOfferClick", homeData.vin + " " + (vehicleDetailsData.selectedTrim.vehicleId ?? vehicleDetailsData.selectedTrim.description.trim));
                                });
                        }
                    });
            }
            else {
                this.setState({ showSpinner: false });
            }
        }
        catch (error) {
            console.logError(error, "YourDetailsRouteComponent", "onGetOfferClick", homeData.vin + " " + (vehicleDetailsData.selectedTrim.vehicleId ?? vehicleDetailsData.selectedTrim.description.trim));
        }
    }

    onBackButtonClick() {
        window.history.go(-1);
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />;
        }

        let homeData = CommonService.getSessionStorage("homeData");
        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        let vehicleConditionData = CommonService.getSessionStorage("vehicleConditionData");
        let headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Your Details", "Default", "Header Html")?.Value;
        if (!headerHtml) {
            headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Header Html")?.Value ?? "";
        }

        let footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Your Details", "Default", "Footer Html")?.Value;
        if (!footerHtml) {
            footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Footer Html")?.Value ?? "";
        }

        let bodyHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Your Details", "Default", "Body Html")?.Value ?? "";
        return <div className="ac-site ac-yourdetails">
            <header className="ac-site-header ac-yourdetails-header" dangerouslySetInnerHTML={{ __html: headerHtml }} />
            <SellToWebProgressbarComponent progressIndex={5} />
            <SellToWebTopPanelComponent imageUrl={vehicleDetailsData?.imageUrl} makePlusModel={vehicleDetailsData?.makePlusModel} trim={(vehicleDetailsData?.selectedTrim?.trimName ?? vehicleDetailsData?.selectedTrim?.description?.trim) ?? "--"} />
            <section className="consumer-page">
                <section className="consumer-main">
                    <section className="ac-site-body ac-yourdetails-body" dangerouslySetInnerHTML={{ __html: bodyHtml }} />
                    <section className="ac-yourdetails-form">
                        <SellToWebInputComponent id="firstName" value={this.state.firstName} placeholder="First Name"
                            isChecked={this.state.firstName}
                            isError={(this.state.firstNameChanged || this.state.isGetOfferClicked) && !this.state.firstName}
                            onTextChange={this.onInputValueChange} onKeyUp={this.onInputValueChange} onKeyDown={this.onTextKeyDown} />
                        <SellToWebInputComponent id="lastName" value={this.state.lastName} placeholder="Last Name"
                            isChecked={this.state.lastName}
                            isError={(this.state.lastNameChanged || this.state.isGetOfferClicked) && !this.state.lastName}
                            onTextChange={this.onInputValueChange} onKeyUp={this.onInputValueChange} onKeyDown={this.onTextKeyDown} />
                        <SellToWebInputComponent id="email" value={this.state.email} placeholder="Email" helperText="(This is where we'll send your offer!)"
                            isChecked={this.state.email && this.emailRegex.test(this.state.email)}
                            isError={(this.state.emailChanged || this.state.isGetOfferClicked) && !(this.state.email && this.emailRegex.test(this.state.email))}
                            onTextChange={this.onInputValueChange} onKeyUp={this.onInputValueChange} onKeyDown={this.onTextKeyDown} />
                        <SellToWebInputComponent id="phone" value={this.state.phone} placeholder="Phone Number"
                            isChecked={this.state.phone && this.state.phone.length >= 10}
                            isError={(this.state.phoneChanged || this.state.isGetOfferClicked) && (!this.state.phone || this.state.phone.length < 10)}
                            onTextChange={this.onPhoneChange} onKeyUp={this.onPhoneChange} onBlur={this.onPhoneBlur} onKeyDown={this.onTextKeyDown} />
                        <SellToWebInputComponent id="zipCode" maxLength={5} value={this.state.zipCode} placeholder="Home Zip Code"
                            isChecked={this.state.zipCode && this.state.zipCode.length === 5}
                            isError={(this.state.zipCodeChanged || this.state.isGetOfferClicked) && !(this.state.zipCode && this.state.zipCode.length === 5)}
                            onTextChange={this.onZipCodeChange} onKeyUp={this.onZipCodeChange} onKeyDown={this.onTextKeyDown} />
                        {
                            this.state.useLocations
                                ? <div className="input-group">
                                    <div className="input-group ac-site-input">
                                        <h4 className={"fw-bold " + ((this.state.isGetOfferClicked && !this.state.selectedLocation) ? "consumer-vehiclecondition-border-error" : "")} style={{ fontSize: "15px", width: "100%" }}>Select Drop-off Location</h4>
                                        <div style={{ "paddingLeft": "3px" }}>
                                            <SellToWebRadioButtonComponent id="selectedLocation" name="rblLocation"
                                                data={this.state.tenantLocation} value={this.state.selectedLocation?.display_name ?? ""} itemKey="display_name" href="addressLink" hrefText="address"
                                                isError={(this.state.selectedLocation || this.state.isGetOfferClicked) && !this.state.selectedLocation}
                                                onChange={this.onLocationChange}
                                            />
                                        </div>
                                    </div>
                                    {
                                        this.state.isGetOfferClicked && !this.state.selectedLocation
                                            ? <span className="fas fa-arrow-left ac-site-error" />
                                            : null
                                    }
                                </div>
                                : null
                        }
                        <div className="d-flex justify-content-end">
                            <div style={{ "cursor": "pointer", "fontSize": "12px", "fontWeight": "400", "textDecoration": "underline", "margin": "auto 30px" }} onClick={(event => { window.history.go(-1); })}>
                                <span className="bi bi-chevron-left" style={{ "marginRight": "5px", "verticalAlign": "middle" }} />
                                Go Back
                            </div>
                            <SellToWebButtonComponent onClick={this.onGetOfferClick} showSpinner={this.state.showSpinner} value="Get Offer!" />
                        </div>
                    </section>
                </section>
                <aside className="consumer-summary">
                    <SellToWebRightPanelComponent
                        vin={homeData?.vin} makePlusModel={vehicleDetailsData?.makePlusModel} valuationMethod={this.props.valuationMethod}
                        imageUrl={vehicleDetailsData?.imageUrl} differentColorShown={vehicleDetailsData?.differentColorShown} odometer={CommonService.formatMoney(vehicleDetailsData?.odometer)}
                        trim={(vehicleDetailsData?.selectedTrim?.trimName ?? vehicleDetailsData?.selectedTrim?.description?.trim) ?? "--"}
                        engine={vehicleDetailsData?.selectedEngine?.optionName ?? "--"}
                        transmission={vehicleDetailsData?.selectedTransmission?.optionName ?? "--"}
                        driveTrain={vehicleDetailsData?.selectedDriveTrain?.optionName ?? "--"}
                        colorBox={vehicleDetailsData?.selectedVehicleOEMColor?.colorBox ? CommonService.checkCSSColorSupports(vehicleDetailsData.selectedVehicleOEMColor.colorBox) : null}
                        colorName={vehicleDetailsData?.selectedVehicleOEMColor?.title ?? vehicleDetailsData?.selectedVehicleOEMColor?.optionName}
                        minimumCondition={vehicleConditionData?.minimumSelectedCondition}
                        siteAttributes={this.props.siteAttributes} applicationInsights={this.state.applicationInsights}
                    />
                </aside>
            </section>
            <footer className="ac-site-footer ac-yourdetails-footer" dangerouslySetInnerHTML={{ __html: footerHtml }} />
        </div>;
    }
}